import { render } from "./Nds.vue?vue&type=template&id=d452f69c&scoped=true"
import script from "./Nds.vue?vue&type=script&lang=js"
export * from "./Nds.vue?vue&type=script&lang=js"

import "./Nds.vue?vue&type=style&index=0&id=d452f69c&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d452f69c"]])

export default __exports__